import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "steps__step-number" }
const _hoisted_2 = { class: "steps__step-title-wrapper" }
const _hoisted_3 = { class: "steps__step-title" }
const _hoisted_4 = {
  key: 0,
  class: "steps__step-form"
}
const _hoisted_5 = ["onSubmit"]
const _hoisted_6 = { class: "mb-24" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h3", { class: "" }, " Project name ", -1 /* HOISTED */)
const _hoisted_8 = { class: "h5" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "notice-bar mb-24" }, [
  /*#__PURE__*/_createElementVNode("p", null, " The project name will take the next available project number, the Company Short Code as defined by the Client Company entry and then the name you have provided in Step 1 ")
], -1 /* HOISTED */)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "notice-bar mb-24" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("b", null, "Take a moment to review your information before creating the project"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" You can edit any section right from this page ")
  ])
], -1 /* HOISTED */)
const _hoisted_11 = ["disabled"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["steps__step", ( $setup.is_completed_step ) ? ' steps__step--completed' : ( $setup.is_current_step ) ? ' steps__step--active' : null])
  }, [
    _createElementVNode("div", _hoisted_1, _toDisplayString($props.step.step_number), 1 /* TEXT */),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString($props.step.title), 1 /* TEXT */)
    ]),
    ($setup.is_current_step)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("form", {
            onSubmit: _withModifiers($setup.updateForm, ["prevent"])
          }, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("p", _hoisted_8, " XXXXX " + _toDisplayString($setup.client_short_code ? $setup.client_short_code + ' ' : '') + _toDisplayString($setup.form_fields.project_name), 1 /* TEXT */)
            ]),
            _hoisted_9,
            _createVNode($setup["InputComponent"], {
              value: $setup.form_fields.notify_slack_channel,
              type: "checkbox",
              "input-id": "send-slack-notification",
              name: "send-slack-notification",
              label: "Send notification to slack channel",
              errors: $setup.form_errors.notify_slack_channel || null,
              "onUpdate:value": _cache[0] || (_cache[0] = new_value => $setup.form_fields.notify_slack_channel = new_value)
            }, null, 8 /* PROPS */, ["value", "errors"]),
            _hoisted_10,
            _createElementVNode("button", {
              class: _normalizeClass(["button button--fill", { 'button--loading': $setup.loading}]),
              type: "submit",
              disabled: $setup.loading
            }, " Create Project ", 10 /* CLASS, PROPS */, _hoisted_11)
          ], 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_5)
        ]))
      : _createCommentVNode("v-if", true)
  ], 2 /* CLASS */))
}